import { clsx } from "clsx";

export default function IconPriceTag({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 5L15.6875 5.28125L4.28125 16.8125L3.59375 17.5L4.28125 18.2187L13.7813 27.7188L14.5 28.4062L15.1875 27.7188L26.7188 16.3125L27 16V5H16ZM16.8438 7H25V15.1563L14.5 25.5938L6.40625 17.5L16.8438 7ZM22 9C21.4479 9 21 9.44792 21 10C21 10.5521 21.4479 11 22 11C22.5521 11 23 10.5521 23 10C23 9.44792 22.5521 9 22 9Z"
        fill="currentColor"
      />
    </svg>
  );
}
